import React from 'react'
import { ImageMagnifier } from '../../'

const LayoutMagnifier = (props) => {
  const {
    elements,
    tip,
  } = props

  return (
    <ImageMagnifier
      elements={elements}
      tip={tip}
    />
  )
}

export default LayoutMagnifier



// WEBPACK FOOTER //
// ./src/modules/houseType/components/layoutMagnifier.jsx